export const resources_EN = {
  emptyNameValidation: "Indtast venligst dit navn",
  emptyEmailValidation: "Indtast venligst din e-mail",
  emptyPasswordValidation: "Indtast venligst din adgangskode",
  emptyConfirmPasswordValidation:
    "Indtast venligst din bekræftelsesadgangskode",
  passwordMatchValidation:
    "Din adgangskode stemmer ikke overens med bekræft adgangskode",
  error: "error",
  errorTitle: "Fejl",
  success: "success",
  successTitle: "Succes",
  emptyFileValidation: "Tilføj venligst opgavebillede",
  emptyTaskTitleValidation: "Indtast opgavens titel",
  emptyTaskDescValidation: "Indtast venligst opgavebeskrivelse",
  emptyTaskDate: "Indtast opgavedato",
  emptyTaskStartMinute: "Indtast venligst starttidspunkt minut",
  emptyTaskStarHour: "Indtast venligst starttid timer",
  emptyTaskEndMinute: "Indtast venligst sluttidsminut",
  emptyTaskEndHour: "Indtast venligst sluttidspunkter",
  emptyMedTitle: "Indtast venligst medicintitel",
  emptyMedQuantity: "Indtast venligst medicinmængde",
  emptyMedDate: "Indtast venligst lagerdato",
  emptyMedComments: "Indtast venligst medicinkommentarer",
  emptyScheduleFileValidation: "Tilføj venligst tidsplanbillede",
  emptyScheduleTitleValidation: "Indtast tidsplanens titel",
  emptyScheduleDescValidation: "Indtast skemabeskrivelse",
  emptyScheduleStartDate: "Indtast venligst planens startdato eller -tidspunkt",
  emptyScheduleEndDate: "Indtast venligst planens slutdato eller tid",
  hoursGreaterThanTwelve:
    "De uren mogen niet groter zijn dan 12 en niet kleiner dan 0.",
  minutesGreaterThan60:
    "De minuten mogen niet groter zijn dan 60 en niet kleiner dan 0.",
  deletePrompt: "Weet je zeker dat je deze taak wilt verwijderen?",
  yesButton: "Ja",
  NoButton: "Nee",
  warningTitle: "Waarschuwing",
  addMorningTask: "Voeg ochtendtaak toe",
  addEveningTask: "Voeg avondtaak toe",
  updateMorningTask: "Werk ochtendtaak bij",
  updateEveningTask: "Werk avondtaak bij",
  noTaskSchedule: "Geen taken gepland",
};
